import { render, staticRenderFns } from "./ChartTestCountByUser.vue?vue&type=template&id=5accc90f&"
import script from "./ChartTestCountByUser.vue?vue&type=script&lang=js&"
export * from "./ChartTestCountByUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports